<template>
    <div class="ui-slider-mobile">
        <ClientOnly>
            <swiper-container ref="containerRef" class="swiper-container" :class="[classes]">
                <slot name="sliders" />
            </swiper-container>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    slidesOffsetBefore: {
        type: Number,
        default: 16
    },

    classes: {
        type: String,
        default: 'swiper-stretch'
    }
});

const containerRef = ref(null);

useSwiper(containerRef, {
    loop: false,
    slidesPerView: 1.35,
    slidesPerGroup: 1,
    spaceBetween: 16,
    slidesOffsetBefore: props.slidesOffsetBefore,
    autoplay: {
        delay: 5000
    }
});
</script>
